import React from 'react'

export interface ActionChipProps {
  label: string
  prependIcon?: React.ReactNode
  appendIcon?: React.ReactNode
  onClick?: () => void | Promise<void>
  className?: string
  as?: 'button' | 'a'
  dataGroup?: string
  href?: string
  target?: '_blank' | '_self'
}

const ActionChip: React.FC<ActionChipProps> = ({
  label = '',
  prependIcon = null,
  appendIcon = null,
  onClick = undefined,
  className = '',
  dataGroup = '',
  as = 'button',
  href = '',
  target = '_self'
}) => {
  const Component = as === 'a' ? 'a' : 'button'
  const anchorProps = as === 'a' ? { href, role: 'button', target } : {}

  return (
    <Component
      onClick={onClick}
      data-group-name={dataGroup}
      className={`flex h-9 cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-transparent bg-primary-100 px-3
      py-1.5 text-sm font-medium text-gray-1100 hover:bg-primary-150 active:bg-primary-200 ${className}`}
      {...anchorProps}
    >
      {prependIcon && (
        <span
          data-group-name={dataGroup}
          className="flex h-4 w-4 items-center justify-center"
        >
          {prependIcon}
        </span>
      )}
      {label}
      {appendIcon && (
        <span
          data-group-name={dataGroup}
          className="flex h-4 w-4 items-center justify-center"
        >
          {appendIcon}
        </span>
      )}
    </Component>
  )
}

export default ActionChip
